<template>
  <custom-modal modal-width="25rem" body-padding="24px" @close="closeModal">
    <template #header>
      <span>Add Details</span>
    </template>

    <template #body>
      <div class="form-container">
        <div class="form-group">
          <label for="controllingArea">Controlling Area:</label>
          <input id="controllingArea" v-model="controllingArea" type="text" />
        </div>
        <div class="form-group">
          <label for="cycle">Cycle Name:</label>
          <input id="cycle" v-model="cycle" type="text" />
        </div>
        <div class="form-group">
          <label for="date">Start Date:</label>
          <input id="date" v-model="date" type="date" />
        </div>
      </div>
    </template>

    <template #footer>
      <button class="btn-cancel" @click="closeModal">Cancel</button>
      <button class="btn-ok" :disabled="!isFormValid" @click="submitForm">Submit</button>
    </template>
  </custom-modal>
</template>

<script>
import CustomModal from "../commons/CustomModal.vue";
import api from "../../store/api";

export default {
  components: { CustomModal },
  data() {
    return {
      controllingArea: "",
      cycle: "",
      date: "",
    };
  },
  computed: {
    isFormValid() {
      return this.controllingArea && this.cycle && this.date; // Ensure all fields are filled
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeydown);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    closeModal() {
      this.$store.dispatch("cells/setCreateSapDialogVisibility", false);

      this.$emit("close");
    },
    async submitForm() {
      try {
        this.$store.dispatch("pdesigns/createProcessFromSAP", {
          controllingArea: this.controllingArea,
          cycle: this.cycle,
          date: this.date,
        });
        this.closeModal();
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },
    handleKeydown(event) {
      if (event.key === "Escape") {
        this.closeModal();
      } else if (event.key === "Enter" && this.isFormValid) {
        this.submitForm();
      }
    },
  },
};
</script>

<style scoped>
.form-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

label {
  font-weight: bold;
  margin-bottom: 0.3rem;
}

input[type="text"],
input[type="date"] {
  width: 100%;
  padding: 0.4rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  outline: none;
}

.btn-cancel,
.btn-ok {
  padding: 0.5rem 1rem;
  font-size: 1rem;
  cursor: pointer;
  border-radius: 4px;
  border: none;
}

.btn-cancel {
  background-color: #f5f5f5;
  color: #333;
  margin-right: 1rem;
}

.btn-ok {
  background-color: #1976d2;
  color: white;
}
</style>
